export interface FAQ {
  question: string;
  answer: string;
}

export const faqData: FAQ[] = [
  {
    question: "直播互动体验平台如何保证用户安全？",
    answer: "我们采用多重安全保护机制，包括实名认证系统、智能内容审核、7×24小时人工巡查团队、以及一键举报功能。所有直播内容均经过AI和人工双重审核，确保平台环境安全可靠。用户隐私数据采用银行级加密技术保护，严格遵守相关法律法规。",
  },
  {
    question: "如何成为一名认证主播？",
    answer: "成为认证主播非常简单：首先注册平台账号并完成实名认证，然后在个人中心提交主播申请，上传必要的身份资料。我们的审核团队会在1-3个工作日内完成审核。通过审核后即可开启直播功能，享受平台提供的流量扶持和收益分成。",
  },
  {
    question: "平台支持哪些直播类型？",
    answer: "我们的平台支持多种直播类型，包括才艺表演（音乐、舞蹈、乐器等）、游戏直播（MOBA、FPS、休闲游戏等）、聊天互动、户外直播、美食直播、体育赛事、知识教育、生活分享等八大类别。未来还将持续扩展更多垂直领域。",
  },
  {
    question: "直播画质支持到什么级别？",
    answer: "平台支持从标清到4K超高清的多档画质选择，系统会根据用户的网络状况自动匹配最佳画质。对于主播端，我们推荐使用1080P及以上的设备进行直播，以获得最佳的画面效果。同时支持HDR显示，让色彩更加真实生动。",
  },
  {
    question: "如何与喜欢的主播互动？",
    answer: "您可以通过多种方式与主播互动：发送弹幕实时交流、赠送虚拟礼物表达支持、参与主播发起的投票和竞猜活动、加入主播粉丝社群、以及在特定活动中申请与主播连麦互动。我们还定期举办线上线下粉丝见面会，拉近主播与粉丝的距离。",
  },
  {
    question: "平台的收费模式是怎样的？",
    answer: "平台采用免费观看+增值服务的模式。观看直播完全免费，用户可以自由浏览所有公开直播内容。增值服务包括虚拟礼物购买、会员订阅、专属勋章等，这些是支持喜爱主播的途径，完全由用户自主选择。我们承诺所有收费项目公开透明。",
  },
  {
    question: "遇到技术问题应该怎么办？",
    answer: "如遇到播放卡顿、画面不清晰等技术问题，建议首先检查您的网络连接状况。您也可以尝试切换画质或刷新页面。如果问题持续存在，请通过「关于我们」页面的联系表单或在线客服联系我们，技术团队会第一时间为您排查解决。",
  },
  {
    question: "平台是否有移动端App？",
    answer: "是的，我们的移动端App已覆盖iOS和Android两大平台。您可以在Apple App Store和各大安卓应用商店搜索「直播互动」下载官方App。移动端App针对手机观看场景进行了深度优化，支持画中画播放、后台音频播放等便捷功能。",
  },
];